import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

interface IProps {
  earnedScore?: number;
  correctAnswersCount?: number;
  incorrectAnswers?: number;
}

const ResultStatistics: React.FC<IProps> = ({ correctAnswersCount, incorrectAnswers, earnedScore }) => {
  const t = useTranslations();

  return (
    <div className="flex items-center justify-between rounded-xl bg-gray-100 py-2">
      <div className="flex w-full flex-col space-y-1 border-r-2 border-gray-300 text-center">
        <div className="flex items-center justify-center gap-1">
          <div className="relative size-4">
            <Image src="/images/total-test-paper.webp" fill alt="Total tests count" title="Umumiy savollar soni" />
          </div>
          <p className="text-xs font-medium">{earnedScore}</p>
        </div>
        <p className="text-[0.6rem] text-gray-400">{t('toplangan_bal')}</p>
      </div>
      <div className="flex w-full flex-col space-y-1 border-r-2 border-gray-300 text-center">
        <div className="flex items-center justify-center gap-1">
          <div className="relative size-4">
            <Image src="/images/correct-answer.webp" fill alt="Correct Answer" title="Tog'ri javob" />
          </div>
          <p className="text-xs font-medium">{correctAnswersCount}</p>
        </div>
        <p className="text-[0.6rem] text-gray-400">{t('togrilar')}</p>
      </div>
      <div className="flex w-full flex-col space-y-1 text-center">
        <div className="flex items-center justify-center gap-1">
          <div className="relative size-4">
            <Image src="/images/incorrect-answer.webp" fill alt="Incorrect Answer" title="Notog'ri javob" />
          </div>
          <p className="text-xs font-medium">{incorrectAnswers}</p>
        </div>
        <p className="text-[0.6rem] text-gray-400">{t('xatolar')}</p>
      </div>
    </div>
  );
};

export default ResultStatistics;
